import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { RotateCcw } from "lucide-react";

export const SystemPromptModal = ({
  open,
  onOpenChange,
  agentName,
  currentPrompt,
  defaultPrompt,
  onSave,
}) => {
  const [draft, setDraft] = useState(currentPrompt);

  useEffect(() => {
    setDraft(currentPrompt);
  }, [currentPrompt, open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="system-prompt-modal"
        className="max-w-2xl bg-brand-deep border border-brand-mint/25 text-brand-mint shadow-2xl shadow-brand-deeper/60"
      >
        <DialogHeader>
          <DialogTitle className="text-brand-mint text-lg tracking-tight">
            Edit System Prompt
          </DialogTitle>
          <DialogDescription className="text-brand-mint/70 text-sm">
            Customize how <span className="text-brand-mintBright font-medium">{agentName}</span> responds. Changes persist across sessions on this device.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-2">
          <label className="text-xs uppercase tracking-widest text-brand-mint/60 font-medium">
            System Prompt
          </label>
          <textarea
            data-testid="system-prompt-textarea"
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            rows={12}
            className="w-full rounded-lg border border-brand-mint/20 bg-brand-deeper/80 px-3.5 py-3 text-sm text-brand-mint placeholder:text-brand-mint/40 focus:outline-none focus:ring-2 focus:ring-brand-mint/50 focus:border-brand-mint resize-none font-mono leading-relaxed"
          />
        </div>

        <DialogFooter className="flex items-center gap-2 sm:justify-between">
          <Button
            variant="ghost"
            type="button"
            data-testid="system-prompt-reset-btn"
            onClick={() => setDraft(defaultPrompt)}
            className="text-brand-mint/70 hover:text-brand-mint hover:bg-brand-deeper/60"
          >
            <RotateCcw className="h-4 w-4 mr-2" />
            Reset to default
          </Button>
          <div className="flex gap-2">
            <Button
              variant="outline"
              type="button"
              data-testid="system-prompt-cancel-btn"
              onClick={() => onOpenChange(false)}
              className="border-brand-mint/25 bg-transparent text-brand-mint hover:bg-brand-deeper/60 hover:text-brand-mintBright"
            >
              Cancel
            </Button>
            <Button
              type="button"
              data-testid="system-prompt-save-btn"
              onClick={() => {
                onSave(draft);
                onOpenChange(false);
              }}
              className="bg-brand-mint hover:bg-brand-mintBright text-brand font-semibold"
            >
              Save
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default SystemPromptModal;
